import { BodyM, HeadingS } from '@/components/Typography'

import type { TitleProps } from '@/models'

import Media, { type Midia } from '../Media'

import { TextBoxStyles, TextBox, MediaWrapper } from './styles'

export interface ContentProps {
  title: TitleProps
  subtitle: TitleProps
}

interface MediaTextBoxProps {
  content: ContentProps
  midia: Midia
}

const MediaTextBox = ({ content, ...midiaProps }: MediaTextBoxProps) => {
  const { midia } = midiaProps
  const hasImage = midia.type === 'image' && !!midia.image?.url
  const hasVideo = midia.type === 'video' && !!midia.video?.url

  return (
    <TextBoxStyles>
      {content && (
        <TextBox>
          <HeadingS
            className="media-text-box__heading"
            tag={content.title?.tag || 'h2'}
            color="dark-medium"
          >
            {content.title?.text}
          </HeadingS>
          <BodyM tag={content.subtitle?.tag || 'p'} color="dark-medium" emphasys={false}>
            {content.subtitle?.text}
          </BodyM>
        </TextBox>
      )}
      {(hasVideo || hasImage) && (
        <MediaWrapper>
          <Media {...midia} aspectRatio="4x3" layout="responsive" />
        </MediaWrapper>
      )}
    </TextBoxStyles>
  )
}
export default MediaTextBox
